import {TradeInstructionsComponent} from "@irb/irb-editors/edit-trading-instructions/trade-instructions/trade-instructions.component";
import {
  formatAlgorithm, formatdefaultOrderPriceTypeForPayload,
  formatExpTypes, formatExpTypesForUpdate,
  formatExpTypesReverse, formatOrderType,
  formatOrderTypeReverse, formatTransaction,
  formatTransactionReverse
} from "@irb-common/formatters";
import {algorithFieldListObj} from "@irb/irb-editors/edit-trading-instructions/trade-instructions/edit-trade-service/algorith-fieldlist-obj";
import {formatDate} from "@angular/common";

export class UpdateOrder {
  orderID: number;
  versionId: number;
  orderAction: string;
  orderStatus: string;
  ordIsNotHeld: boolean;
  orderType: string;
  expirationType: string;
  defaultOrderPriceType?: string;
  price?: number;
  ordLimitPrice?: number;
  ordStopPrice?: number;
  expirationDate?: string;
  notHeldDestination?: string;
  userContactNo?: string;

  transactionType?: string;
  securityType?:string;
  securitySymbol?: string;
  swapExchangeSymbol?: string;
  isSwapExchange?: boolean;
  isActionChanged?: boolean;

  ordNotHeldFillPolicy?: string;
  ordNotHeldInclude?: string;
  ordNotHeldPartRate?: number;
  ordNotHeldMaxVolPct?: number;
  ordNotHeldMaxDispSize?: number;

  ordNotHeldStyle?: string;
  ordNotHeldStartTime?: string;
  ordNotHeldEndTime?: string;
  ordNotHeldAuctionOnly?: boolean;
  ordNotHeldIWPrice?: number;
  notHeldAlgorithm?: string;
  optionOrderType?: string;

  optionStrategyType?: string // not an order field, used only for validation

  // =============== these might go separately
  isSolicited?: boolean;
  isDiscretionary?: boolean;

  reinvestmentDividends?: boolean;
  reinvestmentCapitalGains?: boolean;
  //==============================
  feesOption?: string;
}
export class OrderValidator {
  priceValid = true;
  orderTypeValid = true;
  expirationTypeValid = true;
  expirationDateValid = true;
  ordLimitPriceValid = true;
  ordStopPriceValid = true;
  notHeldDestinationValid = true;
  notHeldAlgorithmValid = true;
  ordNotHeldFillPolicyValid = true;
  ordNotHeldMaxVolPctValid = true;
  ordNotHeldPartRateValid = true;
  ordNotHeldStyleValid = true;
  ordNotHeldMaxDispSizeValid = true;

  ordNotHeldIWPriceValid = true;
  userContactNoValid = true;
  optionOrderTypeValid = true;
  ordNotHeldStartTimeValid = true;
  ordNotHeldEndTimeValid = true;
  isValid(): boolean {
    return this.orderTypeValid &&
    this.priceValid &&
    this.expirationTypeValid &&
    this.expirationDateValid &&
    this.ordLimitPriceValid &&
    this.ordStopPriceValid &&
    this.notHeldDestinationValid &&
    this.notHeldAlgorithmValid &&
    this.ordNotHeldFillPolicyValid &&
    this.ordNotHeldMaxVolPctValid &&
    this.ordNotHeldPartRateValid &&
    this.ordNotHeldStyleValid &&
    this.ordNotHeldMaxDispSizeValid &&
    this.ordNotHeldIWPriceValid &&
    this.userContactNoValid &&
    this.optionOrderTypeValid &&
    this.ordNotHeldStartTimeValid &&
    this.ordNotHeldEndTimeValid;
  }
}

export function validatePhoneNumberFormat(phone: string) {
  if (phone) {
    phone=phone.toString();
    phone = phone.replace(/-/g, "");
  } else {
    return true;
  }
  let valid = true;
  if (isNaN(Number(phone))) {
    valid = false;
  }
  if (phone.length !== 10) {
    valid = false;
  }
  return valid;
}
export class UpdateOrderPayload {
  prevData: UpdateOrder;
  data: UpdateOrder;
  validator: OrderValidator;
  disableMode = false;
  isModified: boolean;
  warningMsg: string = '';
  tradeInstructionsRef: TradeInstructionsComponent;
  isValid(): boolean {
    if (this.tradeInstructionsRef) {
      const tr = this.tradeInstructionsRef;
      if (!tr.mainPropertiesDisabled) {
        if (tr.orderTypeElem && !this.data.orderType && !tr.orderTypeRemainsVarious) {
          this.validator.orderTypeValid = false;
          tr.orderTypeTooltipMsg = tr.orderTypeInvalidMessage;
          //tr.orderTypeElem.styleClass = 'ng-invalid';
          if (tr.orderTypeElem.input) {
            tr.orderTypeElem.input.nativeElement.classList.remove('ng-valid');
            tr.orderTypeElem.input.nativeElement.classList.add('ng-invalid');
          }
        }
        if (tr.blockDeskContact && tr.blockDeskContact.nativeElement) {
          if (!this.validator.userContactNoValid) {
            tr.blockDeskContact.nativeElement.classList.remove('ng-valid');
            tr.blockDeskContact.nativeElement.classList.add('ng-invalid');
            tr.blockDeskContactTooltipMsg = 'Invalid phone number';
            //tr.blockDeskContact.nativeElement.setErrors({'incorrect': true}); // snot a function error
          }
        }
        if (tr.expirationDateElem && tr.expirationDateElem.nativeElement) {
          if (!this.validator.expirationDateValid) {
            tr.expirationDateElem.nativeElement.classList.remove('ng-valid');
            tr.expirationDateElem.nativeElement.classList.add('ng-invalid');
            tr.expirationDateTooltipMsg = 'Invalid Date';
          }
        }
        if (tr.ordNotHeldStartTimeElem && tr.ordNotHeldStartTimeElem.nativeElement) {
          if (!this.validator.ordNotHeldStartTimeValid) {
            tr.ordNotHeldStartTimeTooltipMsg = 'Invalid start time';
            tr.ordNotHeldStartTimeElem.nativeElement.classList.remove('ng-valid');
            tr.ordNotHeldStartTimeElem.nativeElement.classList.add('ng-invalid');
          }
        }
        if (tr.ordNotHeldEndTimeElem && tr.ordNotHeldEndTimeElem.nativeElement) {
          if (!this.validator.ordNotHeldEndTimeValid) {
            tr.ordNotHeldEndTimeTooltipMsg = 'Invalid end time';
            tr.ordNotHeldEndTimeElem.nativeElement.classList.remove('ng-valid');
            tr.ordNotHeldEndTimeElem.nativeElement.classList.add('ng-invalid');
          }
        }
        if (tr.priceElem && tr.priceElem.inputField) {
          if (!this.validator.priceValid) {
            tr.priceElem.tooltipMessage = tr.priceInvalidMessage;
            tr.priceElem.inputField.nativeElement.classList.remove('ng-valid');
            tr.priceElem.inputField.nativeElement.classList.add('ng-invalid');
          }
        }
        if (tr.limitPriceElem && tr.limitPriceElem.inputField) {
          if (!this.validator.ordLimitPriceValid) {
            tr.limitPriceElem.tooltipMessage = tr.priceInvalidMessage;
            tr.limitPriceElem.inputField.nativeElement.classList.remove('ng-valid');
            tr.limitPriceElem.inputField.nativeElement.classList.add('ng-invalid');
          }
        }
        if (tr.stopPriceElem && tr.stopPriceElem.inputField) {
          if (!this.validator.ordStopPriceValid) {
            tr.stopPriceElem.tooltipMessage = tr.stopPriceInvalidMessage;
            tr.stopPriceElem.inputField.nativeElement.classList.remove('ng-valid');
            tr.stopPriceElem.inputField.nativeElement.classList.add('ng-invalid');
          }
        }
        if (tr.ordNotHeldPartRateElem && tr.ordNotHeldPartRateElem.inputField) {
          if (!this.validator.ordNotHeldPartRateValid) {
            tr.ordNotHeldPartRateElem.tooltipMessage = tr.ordNotHeldPartRateInvalidMessage;
            tr.ordNotHeldPartRateElem.inputField.nativeElement.classList.remove('ng-valid');
            tr.ordNotHeldPartRateElem.inputField.nativeElement.classList.add('ng-invalid');
          }
        }
        if (tr.ordNotHeldMaxVolPctElem && tr.ordNotHeldMaxVolPctElem.inputField) {
          if ((!this.validator.ordNotHeldMaxVolPctValid) && tr.ordNotHeldMaxVolPctElem.isRequired) {
            tr.ordNotHeldMaxVolPctElem.tooltipMessage = tr.ordNotHeldMaxVolPctInvalidMessage;
            tr.ordNotHeldMaxVolPctElem.inputField.nativeElement.classList.remove('ng-valid');
            tr.ordNotHeldMaxVolPctElem.inputField.nativeElement.classList.add('ng-invalid');
          } else {
            tr.ordNotHeldMaxVolPctElem.inputField.nativeElement.classList.remove('ng-invalid');
            tr.ordNotHeldMaxVolPctElem.inputField.nativeElement.classList.add('ng-valid');
          }
        }
        if (tr.ordNotHeldMaxDispSizeElem && tr.ordNotHeldMaxDispSizeElem.inputField) {
          if (!this.validator.ordNotHeldMaxDispSizeValid) {
            tr.ordNotHeldMaxDispSizeElem.tooltipMessage = tr.ordNotHeldMaxDispSizeInvalidMessage;
            tr.ordNotHeldMaxDispSizeElem.inputField.nativeElement.classList.remove('ng-valid');
            tr.ordNotHeldMaxDispSizeElem.inputField.nativeElement.classList.add('ng-invalid');
          }
        }
        if (tr.ordNotHeldIWPriceElem && tr.ordNotHeldIWPriceElem.inputField) {
          if (!this.validator.ordNotHeldIWPriceValid) {
            tr.ordNotHeldIWPriceElem.tooltipMessage = tr.ordNotHeldIWPriceInvalidMessage;
            tr.ordNotHeldIWPriceElem.inputField.nativeElement.classList.remove('ng-valid');
            tr.ordNotHeldIWPriceElem.inputField.nativeElement.classList.add('ng-invalid');
          }
        }
        if (tr.expirationTypeElem) {
          if (!this.validator.expirationTypeValid) {
            tr.expirationTypeTooltipMsg = tr.expirationTypeInvalidMessage;
            //tr.expirationTypeElem.styleClass ='ng-invalid';
            if (tr.expirationTypeElem.input) {
              tr.expirationTypeElem.input.nativeElement.classList.remove('ng-valid');
              tr.expirationTypeElem.input.nativeElement.classList.add('ng-invalid');
            }
          }
        }
        if (tr.notHeldDestinationElem) {
          if (!this.validator.notHeldDestinationValid) {
            tr.notHeldDestinationTooltipMsg = tr.notHeldDestinationInvalidMessage;
            //tr.notHeldDestinationElem.styleClass ='ng-invalid';
            if (tr.notHeldDestinationElem.input) {
              tr.notHeldDestinationElem.input.nativeElement.classList.remove('ng-valid');
              tr.notHeldDestinationElem.input.nativeElement.classList.add('ng-invalid');
            }
          }
        }
        if (tr.notHeldAlgorithmElem) {
          if (!this.validator.notHeldAlgorithmValid) {
            tr.notHeldAlgorithmTooltipMsg = tr.notHeldAlgorithmInvalidMessage;
            //tr.notHeldAlgorithmElem.styleClass ='ng-invalid';
            if (tr.notHeldAlgorithmElem.input) {
              tr.notHeldAlgorithmElem.input.nativeElement.classList.remove('ng-valid');
              tr.notHeldAlgorithmElem.input.nativeElement.classList.add('ng-invalid');
            }
          }
        }
        if (tr.ordNotHeldFillPolicyElem) {
          if (!this.validator.ordNotHeldFillPolicyValid) {
            tr.ordNotHeldFillPolicyTooltipMsg = tr.ordNotHeldFillPolicyInvalidMessage;
            //tr.ordNotHeldFillPolicyElem.styleClass ='ng-invalid';
            if (tr.ordNotHeldFillPolicyElem.input) {
              tr.ordNotHeldFillPolicyElem.input.nativeElement.classList.remove('ng-valid');
              tr.ordNotHeldFillPolicyElem.input.nativeElement.classList.add('ng-invalid');
            }
          }
        }
        if (tr.ordNotHeldStyleElem) {
          if (!this.validator.ordNotHeldStyleValid) {
            tr.ordNotHeldStyleTooltipMsg = tr.ordNotHeldStyleInvalidMessage;
            //tr.ordNotHeldStyleElem.styleClass ='ng-invalid';
            if (tr.ordNotHeldStyleElem.input) {
              tr.ordNotHeldStyleElem.input.nativeElement.classList.remove('ng-valid');
              tr.ordNotHeldStyleElem.input.nativeElement.classList.add('ng-invalid');
            }
          }
        }
        if (tr.optionOrderTypeElem) {
          if (!this.validator.optionOrderTypeValid) {
            tr.optionOrderTypeTooltipMsg = tr.optionOrderTypeInvalidMessage;
            //tr.optionOrderTypeElem.styleClass ='ng-invalid';
            if (tr.optionOrderTypeElem.input) {
              tr.optionOrderTypeElem.input.nativeElement.classList.remove('ng-valid');
              tr.optionOrderTypeElem.input.nativeElement.classList.add('ng-invalid');
            }
          }
        }
      }
    }
    return this.validator.isValid();
  }
  getPayload() {
    let dayAafterSixMonth=new Date();
    dayAafterSixMonth.setMonth(dayAafterSixMonth.getMonth()+6);
    const tr = this.tradeInstructionsRef;
    const payload: any = {};
    this.validator= new OrderValidator();
    payload.orderID = this.data.orderID;
    payload.versionId = this.data.versionId;
    payload.orderAction = this.data.orderAction || 'NOTHELD';
    payload.orderStatus = this.data.orderStatus;
    //eliminating nulls in string values
    if (!this.data.userContactNo) { this.data.userContactNo = ''; }
    if (!this.prevData.userContactNo) { this.prevData.userContactNo = ''; }
    

    if (tr.actionType == 'Replace') {
      payload.orderAction = 'REPLACE';
      payload.securitySymbol = this.data.securitySymbol;
      payload.defaultOrderPriceType = this.data.defaultOrderPriceType;
      payload.securityType = this.data.securityType;
    }
    payload.ordIsNotHeld = this.data.ordIsNotHeld;

    payload.orderType = this.data.orderType; // ok. Check for actionType == "MultiEdit" later
    if (this.data.optionOrderType != this.prevData.optionOrderType) payload.optionOrderType = this.data.optionOrderType;

    if (this.data.orderType === 'Various') {
      payload.orderType = null;
    }
    if (tr.actionType == "MultiEdit") {
      payload.expirationType = (this.data.expirationType == "Various") ? null : this.data.expirationType;
      payload.expirationDate = (this.data.expirationDate == null || this.data.expirationDate == "Various" || tr.isShowExpDateVarious) ? null : new Date(formatDate(
        this.data.expirationDate,
        "yyyy-MM-ddThh:mmZ",
        "en-US",
        "ET")).getTime(); //IREBALUX-171
    } else {
      payload.expirationType = this.data.expirationType;
      payload.expirationDate = new Date(formatDate(
        this.data.expirationDate,
        "yyyy-MM-ddThh:mmZ",
        "en-US",
        "ET")).getTime(); //ok
    }
    if (payload.orderType === 'MARKET') {
      payload.expirationDate = null;
    } else if (payload.orderType == "LIMIT") {

      if (this.data.securityType === "OPTION" && this.data.optionStrategyType == "SPREAD") {
        if (!this.data.optionOrderType) {
          this.validator.optionOrderTypeValid = false;
          // return null;
        } else {
          payload.optionOrderType = this.data.optionOrderType;
        }
      }
      payload.price = this.data.price;
      if (this.data.defaultOrderPriceType) { //IREBALUX-1857
        if (tr.actionType === "MultiEdit") {
          payload.price = (this.data.defaultOrderPriceType == 'None') ? this.data.price : 0.0;
        }
        payload.defaultOrderPriceType = this.data.defaultOrderPriceType;
        if ((payload.defaultOrderPriceType == "None") && ((isNaN(payload.price) || !payload.price|| payload.price < 0 ||
          !this.validator.priceValid) /*&& dijit.byId("price").displayedValue != "Various"*/) /*&& !dijit.byId("price").disabled*/
          && !tr.isShowPriceVarious && !tr.priceDisabled) {
          this.validator.priceValid = false;
          // return null;
        }
      }      
 
      if (this.data.expirationType === 'GTD' || this.data.expirationType === 'GTDEXT') {
        if((!this.data.expirationDate ||  new Date(this.data.expirationDate) < new Date()  ||
          new Date(this.data.expirationDate) >  dayAafterSixMonth
          || !this.validator.expirationDateValid) && !tr.isShowExpDateVarious) {
          this.validator.expirationDateValid = false;
        }else {
        payload.expirationType = this.data.expirationType;
        payload.expirationDate = this.data.expirationDate == null ? null : new Date(formatDate(
          this.data.expirationDate,
          "yyyy-MM-ddThh:mmZ",
          "en-US",
          "ET")).getTime();
        }
      }
    } else if (this.data.orderType == "STOP" || this.data.orderType == "TRAILING_STOP_PRC" ||
      this.data.orderType == "Trailing Stop %" || this.data.orderType == "TRAILING_STOP_DOLLAR"
      || this.data.orderType == "Trailing Stop $") {
      //IREBALUX-1338 - Trailing Stop Orders - In-Line Edit - Add Trailing Stop Order Type to Trade Instructions Modal
      if ((!this.data.price || isNaN(this.data.price) || this.data.price < 0 || !this.validator.priceValid) /*&& dijit.byId("price").displayedValue != "Various"*/) {
        this.validator.priceValid = false;
        // return null;
      }
      if((this.data.orderType == "TRAILING_STOP_PRC" || this.data.orderType == "Trailing Stop %") && 
      ( this.data.price <= 0 || this.data.price >99 || this.data.price.toString().indexOf('.') !== -1)){
        this.validator.priceValid = false;
      }

      payload.price = this.data.price;
      if (this.data.expirationType == "GTD" || this.data.expirationType == "GTDEXT"){
          if ((!this.data.expirationDate || new Date(this.data.expirationDate) < new Date()  ||
             new Date(this.data.expirationDate) >  dayAafterSixMonth
              || !this.validator.expirationDateValid) && !tr.isShowExpDateVarious) {
               this.validator.expirationDateValid = false;
            } else {
              payload.expirationType = this.data.expirationType;
              if (!tr.isShowExpDateVarious) {
                payload.expirationDate = this.data.expirationDate == null ? null : new Date(formatDate(
                  this.data.expirationDate,
                  "yyyy-MM-ddThh:mmZ",
                  "en-US",
                  "ET")).getTime();
              }
            }   
      }  
    
    } else if (this.data.orderType == "STOPLIMIT") {
      this.validateStopPrice();
      payload.price = this.data.ordLimitPrice;
      payload.ordStopPrice = this.data.ordStopPrice;
      if (this.data.expirationType == "GTD" || this.data.expirationType == "GTDEXT"){
        if ((!this.data.expirationDate ||  new Date(this.data.expirationDate) < new Date() ||
          new Date(this.data.expirationDate) >  dayAafterSixMonth
        || !this.validator.expirationDateValid) && !tr.isShowExpDateVarious) {
        this.validator.expirationDateValid = false;
        // return null;
      } else {
          payload.expirationType = this.data.expirationType;
          if (!tr.isShowExpDateVarious) {
            payload.expirationDate = this.data.expirationDate == null ? null : new Date(formatDate(
              this.data.expirationDate,
              "yyyy-MM-ddThh:mmZ",
              "en-US",
              "ET")).getTime();
          }
        }
      }
    } else if ((this.data.expirationType == "GTD" || this.data.expirationType == "GTDEXT") && 
    tr.actionType == "MultiEdit" && this.data.orderType == null) {
      payload.expirationType = this.data.expirationType;
      if (!tr.isShowExpDateVarious) {
        payload.expirationDate = this.data.expirationDate == null ? null : new Date(formatDate(
          this.data.expirationDate,
          "yyyy-MM-ddThh:mmZ",
          "en-US",
          "ET")).getTime();
      }
    }
    if (this.data.ordIsNotHeld) {

      if (!this.data.notHeldDestination || !this.validator.notHeldDestinationValid) {
        this.validator.notHeldDestinationValid = false;
        // return null;
      }
      const destination = this.data.notHeldDestination;
      payload.notHeldDestination = destination;
      if (destination == "VIRTU" || destination == "CITADEL") {
        payload.expirationType = "DAY";
        payload.expirationDate = null;
        if (!this.data.notHeldAlgorithm || !this.validator.notHeldAlgorithmValid) {
          this.validator.notHeldAlgorithmValid = false;
          // return null;
        }

        const algorithm = this.data.notHeldAlgorithm;

        payload.notHeldDestination = this.data.notHeldDestination;
        payload.notHeldAlgorithm = this.data.notHeldAlgorithm;
        // todo: find out if needed
        if ( tr.layoutFieldsShowHide && tr.layoutFieldsShowHide.startTimeLay && tr.layoutFieldsShowHide.endTimeLay) {
          if (algorithm !== "COVERT" && algorithm !== "TARGET_CLOSE") {
            const startTime = new Date();
            const startTimeArr = this.data.ordNotHeldStartTime && this.data.ordNotHeldStartTime.split(':') || [];
            const endTime = new Date();
            const endTimeArr = this.data.ordNotHeldEndTime && this.data.ordNotHeldEndTime.split(':') || [];
            
            if (startTimeArr.length >= 2  && endTimeArr.length >= 2) {
              try {
                startTime.setHours(Number(startTimeArr[0]), Number(startTimeArr[1]), 0);
                endTime.setHours(Number(endTimeArr[0]), Number(endTimeArr[1]), 0);

                if (endTime.getTime() <= startTime.getTime()) {
                  this.validator.ordNotHeldStartTimeValid = false;
                  this.validator.ordNotHeldEndTimeValid = false;
                }
              } catch(e) {
                this.validator.ordNotHeldStartTimeValid = false;
                this.validator.ordNotHeldEndTimeValid = false;
              }
            } else if (startTimeArr.length >= 2 && endTimeArr.length === 0) {
              this.validator.ordNotHeldEndTimeValid = false;
            } else if (startTimeArr.length === 0 && endTimeArr.length >= 2) {
              this.validator.ordNotHeldStartTimeValid = false;
            }

            //==========================
            //time range validation
            //==========================
            const minTime = new Date();
            const minTimeArr = tr.ordNotHeldMinTime && tr.ordNotHeldMinTime.split(':') || [];
            const maxTime = new Date();
            const maxTimeArr = tr.ordNotHeldMaxTime && tr.ordNotHeldMaxTime.split(':') || [];
            if (minTimeArr.length >= 2) {
              minTime.setHours(Number(minTimeArr[0]), Number(minTimeArr[1]),0);
              if (startTime.getTime() < minTime.getTime()) {
                this.validator.ordNotHeldStartTimeValid = false;
              }
              if (endTime.getTime() < minTime.getTime()) {
                this.validator.ordNotHeldEndTimeValid = false;
              }
            }
            if (maxTimeArr && maxTimeArr.length >= 2) {
              maxTime.setHours(Number(maxTimeArr[0]), Number(maxTimeArr[1]),0);
              if (startTime.getTime() > maxTime.getTime()) {
                this.validator.ordNotHeldStartTimeValid = false;
              }
              if (endTime.getTime() > maxTime.getTime()) {
                this.validator.ordNotHeldEndTimeValid = false;
              }
            }
            //==============================

          }
        }
        // IREBALUX-12249
        if (!tr.layoutFieldsShowHide.startTimeLay && !tr.layoutFieldsShowHide.endTimeLay && (algorithm === "COVERT" || algorithm === "FAN")) {
          this.data.ordNotHeldStartTime = undefined;
          this.data.ordNotHeldEndTime = undefined;
        }

        if (this.data.ordNotHeldStartTime != undefined) {
          payload.ordNotHeldStartTime = this.data.ordNotHeldStartTime.replace("T", "");
          const startArr = payload.ordNotHeldStartTime.split(':');
          if (startArr.length === 2) {payload.ordNotHeldStartTime += ':00';}
        }
        if (this.data.ordNotHeldEndTime != undefined && algorithm !== "TARGET_CLOSE") {
          payload.ordNotHeldEndTime = this.data.ordNotHeldEndTime.replace("T", "");
          const endtArr = payload.ordNotHeldEndTime.split(':');
          if (endtArr.length === 2) {payload.ordNotHeldEndTime += ':00';}
        }
        if (destination == "CITADEL" && (algorithm == "TWAP" || algorithm == "VWAP" || algorithm == "PERCENTAGE_OF_VOLUME")) {
          if (!this.data.ordNotHeldFillPolicy || !this.validator.ordNotHeldFillPolicyValid) {
            this.validator.ordNotHeldFillPolicyValid = false;
            // return null;
          }
          payload.ordNotHeldFillPolicy = this.data.ordNotHeldFillPolicy;
        }
        if ((destination == "VIRTU" && (algorithm == "TWAP" || algorithm == "PERCENTAGE_OF_VOLUME" || algorithm == "OPPORTUNISTIC" || algorithm == "CATCH"))) {
          if (!this.data.ordNotHeldMaxVolPct || !this.validator.ordNotHeldMaxVolPctValid) {
            this.validator.ordNotHeldMaxVolPctValid = false;
          }
          payload.ordNotHeldMaxVolPct = this.data.ordNotHeldMaxVolPct;
        }
        if ((destination == "VIRTU" && (algorithm == "VWAP"))) {
          if ((!this.data.ordNotHeldMaxVolPct || !this.validator.ordNotHeldMaxVolPctValid) && tr.ordNotHeldMaxVolPctElem.isRequired) {
            this.validator.ordNotHeldMaxVolPctValid = false;
          }
          payload.ordNotHeldMaxVolPct = this.data.ordNotHeldMaxVolPct;
        }
        if (destination == "CITADEL" && algorithm == "PERCENTAGE_OF_VOLUME") {
          if (!this.data.ordNotHeldPartRate || !this.validator.ordNotHeldPartRateValid) {
            this.validator.ordNotHeldPartRateValid = false;
            // return null;
          }
          payload.ordNotHeldPartRate = Number(this.data.ordNotHeldPartRate);
          payload.ordNotHeldInclude = (this.data.ordNotHeldInclude == "Include") ? true : false;
        }
        if (destination == "VIRTU" && (algorithm == "OASIS" || algorithm == "COVERT" || algorithm == "FAN" || algorithm == "ARRIVAL" || algorithm == "OPPORTUNISTIC" || algorithm == "CATCH" || algorithm === "TARGET_CLOSE")) {
          if (!this.data.ordNotHeldStyle || !this.validator.ordNotHeldStyleValid) {
            this.validator.ordNotHeldStyleValid = false;
            return false;
          }
          payload.ordNotHeldStyle = this.data.ordNotHeldStyle;
        }
        if (destination == "VIRTU" && algorithm == "FAN") {
          this.validator.ordNotHeldMaxDispSizeValid = (Number(this.data.ordNotHeldMaxDispSize) <= Number(tr.data.quantity));
            if (this.validator.ordNotHeldMaxDispSizeValid) {
              payload.ordNotHeldMaxDispSize = this.data.ordNotHeldMaxDispSize;
            }
        }
        if(destination === "VIRTU" && algorithm === "TARGET_CLOSE") {
          payload.ordNotHeldAuctionOnly = this.data.ordNotHeldAuctionOnly || false;
        }
        /*if (destination == "VIRTU" && algorithm == "ARRIVAL") {
          //if (dojo.byId("iWPriceLay").style.display != "none") {
            if (!this.validator.ordNotHeldIWPriceValid) {
              // return null;
            }
          //}
          payload.ordNotHeldIWPrice = this.data.ordNotHeldIWPrice;
        }*/
      } else if (destination == "AOM_PRINTER") {
        this.validator.userContactNoValid = validatePhoneNumberFormat(this.data.userContactNo);
        if (this.validator.userContactNoValid) {
          payload.userContactNo = this.data.userContactNo.toString();
          payload.userContactNo = payload.userContactNo.replace(/-/g, "");
        } else {
          // return null;
        }

        if (payload.orderType == "MARKET") {
          payload.expirationType = "DAY";
          payload.expirationDate = null;
        }
      }
    }
    /////////////
    let byPassableWaringObj = {
      "orderTypeTrade": payload.orderType,
      "orderTypePass": (payload.orderType == "STOPLIMIT"
        || payload.orderType == "STOP"
        || payload.orderType == "LIMIT") ? true : false,
      "priceUser": (payload.orderType == "STOPLIMIT") ? this.data.ordStopPrice : this.data.price,
      "attachTooltipID": (payload.orderType == "STOPLIMIT") ? "stopprice" : "price"
    };
    if (tr.actionType != "MultiEdit") {
      payload.expirationType = formatExpTypesForUpdate(payload.expirationType);

      if (payload.defaultOrderPriceType) {
        payload.defaultOrderPriceType = formatdefaultOrderPriceTypeForPayload(payload.defaultOrderPriceType);
      }
      if (payload.orderType == "TRAILING_STOP_PRC" || payload.orderType == "TRAILING_STOP_DOLLAR") {
        payload.defaultOrderPriceType = null;
      }
      payload.orderType = formatOrderType(payload.orderType);
      if (this.data.transactionType != this.prevData.transactionType) payload.transactionType = formatTransaction(this.data.transactionType);
      if (this.data.notHeldAlgorithm != this.prevData.notHeldAlgorithm) payload.notHeldAlgorithm = this.data.notHeldAlgorithm; //formatAlgorithm(this.data.notHeldAlgorithm);

      if (this.data.isSolicited !== null) {
        /* f (this.data.isSolicited != this.prevData.isSolicited) */ payload.isSolicited = this.data.isSolicited;
      }
      if (this.data.isDiscretionary !== null) {
        /* if (this.data.isDiscretionary != this.prevData.isDiscretionary) */ payload.isDiscretionary = this.data.isDiscretionary;
      }
      if (this.data.reinvestmentDividends !== null) {
        if (this.data.reinvestmentDividends != this.prevData.reinvestmentDividends) payload.isDividendReinvest = this.data.reinvestmentDividends;
      }
      if (this.data.reinvestmentCapitalGains !== null) {
        if (this.data.reinvestmentCapitalGains != this.prevData.reinvestmentCapitalGains) payload.isCapGainsReinvest = this.data.reinvestmentCapitalGains;
      }
      if (this.data.feesOption !== null) {
        if (this.data.feesOption != this.prevData.feesOption) payload.feesOption = this.data.feesOption;
      }
      if (this.data.swapExchangeSymbol !== null) {
        if (this.data.swapExchangeSymbol != this.prevData.swapExchangeSymbol) payload.swapExchangeSymbol = this.data.swapExchangeSymbol;
      }

      if (this.data.isSwapExchange !== null) {
        if (this.data.isSwapExchange != this.prevData.isSwapExchange) payload.isSwapExchange = this.data.isSwapExchange;
      }

      if (this.data.isActionChanged !== null) {
        if (this.data.isActionChanged != this.prevData.isActionChanged) payload.isActionChanged = this.data.isActionChanged;
      }

    }
    if (byPassableWaringObj.orderTypePass && tr.actionType != "MultiEdit") {
      //if (this.data.ordLimitPrice != this.prevData.ordLimitPrice) payload.ordLimitPrice = this.data.ordLimitPrice; // check later for "Various"

      /*
                 * IREBALOPNS-1843
                 * Create and Edit Trade Instructions modal for Spread orders
                 */
      // todo: warning popup - finish
      const currentUnitPrice = tr.spreadOptionAction("isSpreadOrder") ? tr.spreadOptionAction("getCurrentUnitPrice") : (tr.data.currentUnitPrice ? tr.data.currentUnitPrice : 0)
      const different = (Number(byPassableWaringObj.priceUser - currentUnitPrice) * 100) / currentUnitPrice;
      const isLimitOtherTypePrice = (payload.defaultOrderPriceType && payload.defaultOrderPriceType != 'None' && payload.orderType == "Limit")?true:false;
      if ((different > 20 || different < -20) && !tr.priceDisabled && !isLimitOtherTypePrice) {
        this.warningMsg = "Please confirm the " + ((payload.orderType == "Limit") ? "limit" : "stop") + " price you " +
          " entered - it's more than 20% different from the current market price."
      }else{
        this.warningMsg = '';
      }
    } else {
      this.warningMsg = '';
      const multiRecords = tr.multiRecords; // todo: this is just a place holder for now
      const payloadMult: any[] = [];
      var cellNameActionType = "viewEditTradeIns";
      if (tr.actionType == "MultiEdit") {
        if (multiRecords) {
          var updateValuesToObj = [];

          multiRecords.forEach((item) => {
            // for (key in item) {
            //   if (key != "orderID" && key != "versionId" && key != "orderStatus" && key != "orderType" && (dojo.byId("ordIsNotHeldVarious").innerHTML != "Various" && key != "ordIsNotHeld")) {
            //     delete item[key];
            //   } else {
            //     item[key] = item[key];
            //   }
            // }
            const payloadItem: any = {};
            payloadItem.orderID = item.orderID;
            payloadItem.versionId = item.versionId;
            payloadItem.orderStatus = item.orderStatus;
            payloadItem.orderType = item.orderType;
            payloadItem.ordIsNotHeld = item.ordIsNotHeld  != null ? item.ordIsNotHeld : false;
            payloadItem.expirationDate = item.expirationDate;
            const notHeldDestination = payload.notHeldDestination;
            const notHeldAlgorithm = payload.notHeldAlgorithm;
            if (notHeldDestination && notHeldAlgorithm) {
              const currentFields = algorithFieldListObj(notHeldDestination, notHeldAlgorithm);
              const listofFields = currentFields.length ? currentFields[0].listofFields : [];
              payloadItem.notHeldDestination = notHeldDestination;
              payloadItem.notHeldAlgorithm = notHeldAlgorithm;

              for (let i = 0; i < listofFields.length; i++) {
                payloadItem[listofFields[i]] = payload[listofFields[i]];
              }
            }

            payloadItem.orderAction = payload.orderAction;
            if (tr.ordIsNotHeldVarious != "Various") {
              payloadItem.ordIsNotHeld = payload.ordIsNotHeld;
            }
            if (!tr.isSolictedVarious) {
              payloadItem.isSolicited = tr.isSolicited;
            }
            if (!tr.isDiscretionaryVarious) {
              payloadItem.isDiscretionary = tr.isDiscretionary;
            }

            payload.defaultOrderPriceType = formatdefaultOrderPriceTypeForPayload(payload.defaultOrderPriceType);

            if (this.data.transactionType != this.prevData.transactionType) payload.transactionType = formatTransaction(this.data.transactionType);
            if (this.data.notHeldAlgorithm != this.prevData.notHeldAlgorithm) payload.notHeldAlgorithm = this.data.notHeldAlgorithm; //formatAlgorithm(this.data.notHeldAlgorithm);
            //IREBALUX-165 changes

            if (this.data.reinvestmentDividends !== null) {
              if (this.data.reinvestmentDividends != this.prevData.reinvestmentDividends) payloadItem.isDividendReinvest = this.data.reinvestmentDividends;
            }
            if (this.data.reinvestmentCapitalGains !== null) {
              if (this.data.reinvestmentCapitalGains != this.prevData.reinvestmentCapitalGains) payloadItem.isCapGainsReinvest = this.data.reinvestmentCapitalGains;
            }
            if (this.data.feesOption !== null) {
              if (this.data.feesOption != this.prevData.feesOption) payloadItem.feesOption = this.data.feesOption;
            }
            if (typeof payload.price != "undefined" && !tr.isShowPriceVarious) {
              payloadItem.price = payload.price;
            }
            if (typeof payload.ordStopPrice != "undefined"  && !tr.isShowStopPriceVarious) {
              payloadItem.ordStopPrice = payload.ordStopPrice;
            }
            if (payload.notHeldDestination) {
              payloadItem.notHeldDestination = payload.notHeldDestination;
            }
            if (payload.userContactNo) {
              payloadItem.userContactNo = payload.userContactNo;
            }

            //added for IREBALUX-170 start
            if (payload.expirationType) {
              payloadItem.expirationType = formatExpTypesForUpdate(payload.expirationType);
            } else {
              if (item.expirationType) {
                const expType = formatExpTypesReverse(item.expirationType);
                if (tr.expTypes.map((expTypeItem) => expTypeItem.value).includes(expType)) {
                } else {
                  this.validator.expirationTypeValid = false;
                }
              }
            }
            //added for IREBALUX-170 end
            //added for IREBALUX-171
            if (payload.expirationDate) {
              payloadItem.expirationDate = new Date(formatDate(
                payload.expirationDate,
                "yyyy-MM-ddThh:mmZ",
                "en-US",
                "ET")).getTime();
            }
            //IREBALUX-1857
            if (payload.orderType == "LIMIT") {
              payloadItem.defaultOrderPriceType = formatdefaultOrderPriceTypeForPayload(payload.defaultOrderPriceType);
            } else if (payload.orderType == "TRAILING_STOP_PRC" || payload.orderType == "TRAILING_STOP_DOLLAR") {
              payloadItem.defaultOrderPriceType = null;
            }
            if (payload.orderType) {
              payloadItem.orderType = formatOrderType(payload.orderType);
            }
            if (payload.optionOrderType) {
              payloadItem.optionOrderType = payload.optionOrderType;
            }
            payloadMult.push(payloadItem);
          });
          // editedValuesObj = multiRecords;
          // cellNameActionType = "viewEditTradeInsMulti";
          if (this.validator.isValid()) {
            return payloadMult;
          }
          return null;
        }
      }
    }
    if (this.validator.isValid()) {
      return payload;
    }
    return null;
  }
  validateStopPrice() {
    this.tradeInstructionsRef.stopPriceInvalidMessage = '';
    if ((!this.data.ordLimitPrice || isNaN(this.data.ordLimitPrice) || this.data.ordLimitPrice < 0 ||!this.validator.ordLimitPriceValid) /*&& dijit.byId("limitprice").displayedValue != "Various"*/) {
      this.validator.ordLimitPriceValid = false;
      this.tradeInstructionsRef.stopPriceInvalidMessage = this.tradeInstructionsRef.priceInvalidMessage;

    }
    if ((!this.data.ordStopPrice || isNaN(this.data.ordStopPrice) || this.data.ordStopPrice < 0 || !this.validator.ordStopPriceValid) /*&& dijit.byId("limitprice").displayedValue != "Various"*/) {
      this.validator.ordStopPriceValid = false;
      this.tradeInstructionsRef.stopPriceInvalidMessage = this.tradeInstructionsRef.priceInvalidMessage;

    }
    const isBuyType = this.data.transactionType == "BUY" ||
      this.data.transactionType == "BUY_TO_CLOSE" || this.data.transactionType == "Buy to close"
      || this.data.transactionType == "BUY_TO_OPEN" || this.data.transactionType == "Buy to open";
    const isSellType = this.data.transactionType == "SELL" || this.data.transactionType == "SELL_ALL"
      || this.data.transactionType == "SELL_TO_OPEN"
      || this.data.transactionType == "SELL_TO_CLOSE";
    if (isBuyType && (Number(this.data.ordLimitPrice) < Number(this.data.ordStopPrice))) {
      //stopPrice.set("message", "A Limit Price can be equal to or higher than the Stop Price but not lower than the Stop Price.");
      this.tradeInstructionsRef.stopPriceInvalidMessage = this.tradeInstructionsRef.stopPriceInvalidMessageBuy;
      this.validator.ordStopPriceValid = false;

    } else if (isSellType && ( Number(this.data.ordStopPrice) < Number(this.data.ordLimitPrice))) {
      // stopPrice.set("message", "A Limit Price can be equal to or lower than the Stop Price but not higher than the Stop Price.");
      this.tradeInstructionsRef.stopPriceInvalidMessage = this.tradeInstructionsRef.stopPriceInvalidMessageSell;
      this.validator.ordStopPriceValid = false;

    }
  }
}
